import React from 'react';
import { ToastContainer } from 'react-toastify';

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from 'react-router-dom';

import Login from '../pages/Login/components';
import Covenant from '../pages/Covenant/components';

import { setAPI } from './api';

setAPI();

const Routes = () => {
  return(
    <Router>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        style={{ zIndex: 1999 }}
      />
      <Switch>
        <Route exact path='/' render={ () => (<Redirect to='/login' />) }/>
        <Route path='/login' component={ Login }/>
        <Route path='/ativacao-convenio' component={ Covenant }/>
      </Switch>
    </Router>
  )
}

export default Routes;


// WEBPACK FOOTER //
// ./src/routes/Routes.js